import styles from "./OrderCombobox.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useOrderComboBox } from "./useOrderCombobox";
import Icon from "../../../assets/icons";
import { defaultDateDisplay } from "../../../helpers";

const OrderComboBox = ({
  error = "" | null,
  label,
  onChange,
  defaultOrderId = null,
  isDisabled = false,
}) => {
  const {
    combobox,
    selectedOrder,
    orders,
    displayMenu,
    showSpinner,
    isLoadingDefaultOrder,
  } = useOrderComboBox({ onChange, defaultOrderId });

  return (
    <div className={styles.orderComboBox}>
      <input type="hidden" name="order_id" value={selectedOrder?.id || ""} />
      <div className={styles.orderComboBoxLabel}>
        <label {...combobox.getLabelProps()}>
          <span>{label}</span>
        </label>
        {error ? (
          <em
            id="order-errorr"
            style={{ color: "red" }}
            className="text--danger"
          >
            {error}
          </em>
        ) : null}
      </div>
      <div className={styles.orderComboBoxControl}>
        <SeachIcon />
        {isDisabled ? (
          <input
            type="text"
            className={styles.orderComboBoxInput}
            value={selectedOrder?.id || defaultOrderId || ""}
            disabled
            readOnly
          />
        ) : (
          <input
            type="text"
            {...combobox.getInputProps({
              placeholder: "Search by Order ID",
              className: styles.orderComboBoxInput,
              "aria-invalid": Boolean(error) || undefined,
              "aria-errormessage": error ? "customer-error" : undefined,
            })}
          />
        )}
        {/* Show spinner here... */}
        <Spinner showSpinner={showSpinner || isLoadingDefaultOrder} />
      </div>
      <ul
        {...combobox.getMenuProps({ className: styles.orderComboBoxMenu })}
        style={{
          visibility: !displayMenu || isDisabled ? "hidden" : "visible",
        }}
      >
        {displayMenu && !isDisabled
          ? orders?.map((order, index) => (
              <li
                key={order?.id}
                {...combobox.getItemProps({
                  className: styles.orderComboBoxMenuItem,
                  key: order?.id,
                  item: order,
                  index,
                })}
              >
                <span>{order.id}</span>
                <span>{defaultDateDisplay(order.created_at)}</span>
              </li>
            ))
          : null}
      </ul>
    </div>
  );
};

function Spinner({ showSpinner = true }) {
  return (
    <div
      style={{
        position: "absolute",
        top: "50%",
        right: 0,
        transform: "translateY(-50%)",
        opacity: showSpinner ? "100" : "0",
      }}
    >
      <FontAwesomeIcon
        icon={["fas", "spinner"]}
        className="fa-spin mr-2 purple--text"
      />
    </div>
  );
}

function SeachIcon() {
  return (
    <div
      style={{
        position: "absolute",
        top: "50%",
        left: 0,
        transform: "translateY(-50%)",
      }}
    >
      <img src={Icon.search} alt="" className="ml-2" />
    </div>
  );
}

export default OrderComboBox;
